<template>
  <div>
    <div class="row d-flex justify-content-center">
      <div class="col-md-10 mr-auto ml-auto">

          <wizard @complete="wizardComplete">
            <template slot="header">
              <h3 class="card-title"></h3>
              <h3 class="description"></h3>
            </template>

            <wizard-tab :before-change="() => validateStep('step1')">
              <template slot="label" >
                <i class="nc-icon nc-basket"></i>
                Contracts
              </template>
              <first-step ref="step1" @on-validated="onStepValidated"></first-step>
            </wizard-tab>

            <wizard-tab :before-change="() => validateStep('step2')">
              <template slot="label">
                <i class="nc-icon nc-single-02"></i>
                Company
              </template>
              <second-step ref="step2" @on-validated="onStepValidated"></second-step>
            </wizard-tab>

            <wizard-tab :before-change="() => validateStep('step3')">
              <template slot="label" >
                <i class="nc-icon nc-bullet-list-67"></i>
                Suppliers
              </template>
              <third-step :contracts='wizardModel' ref="step3" @on-validated="onStepValidated"></third-step>
            </wizard-tab>

            <wizard-tab :before-change="() => validateStep('step4')">
              <template slot="label">
                <i class="nc-icon nc-single-copy-04"></i>
                Confirm
              </template>
              <fourth-step :contracts='wizardModel' ref="step4" @on-validated="onStepValidated"></fourth-step>
            </wizard-tab>


          </wizard>



      </div>

    </div>
  </div>
</template>
<script>
  import FirstStep from './Wizard/FirstStep.vue'
  import SecondStep from './Wizard/SecondStep.vue'
  import ThirdStep from './Wizard/ThirdStep.vue'
  import FourthStep from './Wizard/FourthStep.vue'
  import swal from 'sweetalert2'
  import {Wizard, WizardTab} from 'src/components/UIComponents'
  //import vueEsign from 'vue-esign'


  export default {
    data() {
      return {
        wizardModel: {},
      }
    },
    components: {
      FirstStep,
      SecondStep,
      ThirdStep,
      FourthStep,
      Wizard,
      WizardTab
    },
    methods: {
      checkResp(data) {
        if(data.message) {
          this.$notify({
            message: 'Impossible to generate this contract',
            type: 'danger',
            horizontalAlign: 'center',
            verticalAlign: 'top'
          })
        } else {
          console.log(data)
          this.$router.push({ path: `/search/contracts` })
        }
      },
      genContract(ref) {
        this.$http({
          method: 'post',
          url: this.$apiUrl + '/contract/contract',
          headers: {'Authorization': 'Bearer ' + localStorage.token},
          data: ref
        }).then(response => (
                this.checkResp(response.data)
        )).catch(err => {
          this.$notify({
            message: 'Impossible to generate this contract',
            type: 'danger',
            horizontalAlign: 'center',
            verticalAlign: 'top'
          })
        })
      },
      validateStep(ref) {
        return this.$refs[ref].validate()
      },
      onStepValidated(validated, model) {
        console.log(validated)
        this.wizardModel = {...this.wizardModel, ...model}
      },
      wizardComplete() {
        if(this.wizardModel.sign) {
          console.log('wizardcomplete')
          this.genContract(this.wizardModel)
          console.log(this.wizardModel)
          //swal('Contracts generated', '', 'success')

        } else {
          this.$notify({
            message: 'You have to sign the contract before',
            type: 'danger',
            horizontalAlign: 'center',
            verticalAlign: 'top'
          })
        }

      }
    }
  }
</script>
